(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-stickers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (root.dataset.hsReady === 'true') return;
      root.dataset.hsReady = 'true';

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var track = root.querySelector('.hero-stickers__track');
      var slides = root.querySelectorAll('.hero-stickers__slide');
      var dots = root.querySelectorAll('.hero-stickers__dot');
      var count = slides.length;
      var index = 0;
      var auto = null;

      function render() {
        if (track) track.style.transform = 'translateX(' + (-index * 100) + '%)';
        for (var d = 0; d < dots.length; d++) {
          var on = d === index;
          if (on) { dots[d].classList.add('is-active'); } else { dots[d].classList.remove('is-active'); }
        }
        for (var s = 0; s < slides.length; s++) {
          var sActive = s === index;
          if (sActive) { slides[s].classList.add('is-active'); } else { slides[s].classList.remove('is-active'); }
          slides[s].setAttribute('aria-hidden', sActive ? 'false' : 'true');
        }
      }

      function go(i) { index = (i + count) % count; render(); }

      var interval = parseInt(root.getAttribute('data-interval'), 10) || 5;
      var autoplay = root.getAttribute('data-autoplay') === 'true' && count > 1 && !reduce;

      function startAuto() { if (autoplay && !auto) { auto = setInterval(function () { go(index + 1); }, interval * 1000); } }
      function stopAuto() { if (auto) { clearInterval(auto); auto = null; } }

      root._hsGo = go;
      root._hsStop = stopAuto;

      var prev = root.querySelector('.hero-stickers__arrow--prev');
      var next = root.querySelector('.hero-stickers__arrow--next');
      if (prev) prev.addEventListener('click', function () { go(index - 1); stopAuto(); });
      if (next) next.addEventListener('click', function () { go(index + 1); stopAuto(); });
      for (var d = 0; d < dots.length; d++) {
        (function (di) { dots[di].addEventListener('click', function () { go(di); stopAuto(); }); })(d);
      }

      root.addEventListener('mouseenter', stopAuto);
      root.addEventListener('mouseleave', startAuto);
      root.addEventListener('focusin', stopAuto);

      var layers = root.querySelectorAll('[data-depth]');
      var pEnabled = root.getAttribute('data-parallax') === 'true' && !reduce && layers.length > 0;
      var ticking = false;
      var inView = true;

      function pUpdate() {
        ticking = false;
        if (!inView || !pEnabled) return;
        var progress = -root.getBoundingClientRect().top;
        for (var i = 0; i < layers.length; i++) {
          var depth = parseFloat(layers[i].getAttribute('data-depth')) || 0;
          layers[i].style.setProperty('--parallax-y', (progress * depth).toFixed(1) + 'px');
        }
      }
      function pReq() { if (!ticking) { ticking = true; window.requestAnimationFrame(pUpdate); } }

      if (pEnabled) {
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (e) { inView = e[0].isIntersecting; if (inView) pReq(); });
          io.observe(root);
        }
        window.addEventListener('scroll', pReq, { passive: true });
        window.addEventListener('resize', pReq, { passive: true });
        pUpdate();
      }

      render();
      startAuto();
    }

    function boot() {
      var sections = document.querySelectorAll('.hero-stickers');
      for (var i = 0; i < sections.length; i++) initSection(sections[i]);
    }

    if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }

    document.addEventListener('shopify:section:load', boot);

    document.addEventListener('shopify:block:select', function (event) {
      var root = event.target.closest('.hero-stickers');
      if (!root || typeof root._hsGo !== 'function') return;
      var slide = event.target.closest('.hero-stickers__slide');
      if (!slide) return;
      if (root._hsStop) root._hsStop();
      root._hsGo(parseInt(slide.getAttribute('data-slide-index'), 10) || 0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (root.dataset.pbReady === 'true') return;
      root.dataset.pbReady = 'true';

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var slides = root.querySelectorAll('.pbanner__slide');
      var dots = root.querySelectorAll('.pbanner__dot');
      var count = slides.length;
      if (count === 0) return;
      var index = 0;
      var auto = null;

      function render() {
        for (var s = 0; s < slides.length; s++) {
          if (s === index) { slides[s].classList.add('is-active'); } else { slides[s].classList.remove('is-active'); }
          slides[s].setAttribute('aria-hidden', s === index ? 'false' : 'true');
        }
        for (var d = 0; d < dots.length; d++) {
          if (d === index) { dots[d].classList.add('is-active'); } else { dots[d].classList.remove('is-active'); }
        }
      }
      function go(i) { index = (i + count) % count; render(); }

      var interval = parseInt(root.getAttribute('data-interval'), 10) || 5;
      var autoplay = root.getAttribute('data-autoplay') === 'true' && count > 1 && !reduce;
      function startAuto() { if (autoplay && !auto) { auto = setInterval(function () { go(index + 1); }, interval * 1000); } }
      function stopAuto() { if (auto) { clearInterval(auto); auto = null; } }

      root._pbGo = go;
      root._pbStop = stopAuto;

      var prev = root.querySelector('.pbanner__arrow--prev');
      var next = root.querySelector('.pbanner__arrow--next');
      if (prev) prev.addEventListener('click', function () { go(index - 1); stopAuto(); });
      if (next) next.addEventListener('click', function () { go(index + 1); stopAuto(); });
      for (var d = 0; d < dots.length; d++) {
        (function (di) { dots[di].addEventListener('click', function () { go(di); stopAuto(); }); })(d);
      }
      root.addEventListener('mouseenter', stopAuto);
      root.addEventListener('mouseleave', startAuto);
      root.addEventListener('focusin', stopAuto);

      render();
      startAuto();
    }

    function boot() {
      var sections = document.querySelectorAll('.pbanner');
      for (var i = 0; i < sections.length; i++) initSection(sections[i]);
    }

    if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', function (event) {
      var root = event.target.closest('.pbanner');
      if (!root || typeof root._pbGo !== 'function') return;
      var slide = event.target.closest('.pbanner__slide');
      if (!slide) return;
      if (root._pbStop) root._pbStop();
      root._pbGo(parseInt(slide.getAttribute('data-slide-index'), 10) || 0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-stickers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (root.dataset.prReady === 'true') return;
      root.dataset.prReady = 'true';

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var layers = root.querySelectorAll('[data-depth]');
      var enabled = root.getAttribute('data-parallax') === 'true' && !reduce && layers.length > 0;
      if (!enabled) return;

      var ticking = false;
      var inView = true;

      function update() {
        ticking = false;
        if (!inView) return;
        var progress = -root.getBoundingClientRect().top;
        for (var i = 0; i < layers.length; i++) {
          var depth = parseFloat(layers[i].getAttribute('data-depth')) || 0;
          layers[i].style.setProperty('--parallax-y', (progress * depth).toFixed(1) + 'px');
        }
      }
      function req() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (e) { inView = e[0].isIntersecting; if (inView) req(); });
        io.observe(root);
      }
      window.addEventListener('scroll', req, { passive: true });
      window.addEventListener('resize', req, { passive: true });
      update();
    }

    function boot() {
      var sections = document.querySelectorAll('.promo');
      for (var i = 0; i < sections.length; i++) initSection(sections[i]);
    }

    if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTesti(root) {
      if (root.dataset.wtReady === '1') return;
      root.dataset.wtReady = '1';

      var track = root.querySelector('.wuf-testi__track');
      var slides = root.querySelectorAll('.wuf-testi__slide');
      var dots = root.querySelectorAll('[data-wt-dot]');
      var prev = root.querySelector('[data-wt-prev]');
      var next = root.querySelector('[data-wt-next]');
      var n = slides.length;
      if (!track || n === 0) return;
      var i = 0;

      function render() {
        track.style.transform = 'translateX(' + (-i * 100) + '%)';
        for (var d = 0; d < dots.length; d++) {
          if (d === i) { dots[d].classList.add('is-active'); }
          else { dots[d].classList.remove('is-active'); }
        }
      }
      function go(k) { i = (k + n) % n; render(); }

      if (prev) prev.addEventListener('click', function () { go(i - 1); stop(); });
      if (next) next.addEventListener('click', function () { go(i + 1); stop(); });
      for (var d = 0; d < dots.length; d++) {
        (function (idx) {
          dots[idx].addEventListener('click', function () { go(idx); stop(); });
        })(d);
      }

      var timer = null;
      var delay = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
      function start() { if (delay > 0 && n > 1) { timer = setInterval(function () { go(i + 1); }, delay * 1000); } }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      render();
      start();
    }

    function boot() {
      var all = document.querySelectorAll('[data-wuf-testi]');
      for (var i = 0; i < all.length; i++) initTesti(all[i]);
    }

    if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trending-collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.tsReady === 'true') return;
      root.dataset.tsReady = 'true';

      var grid = root.querySelector('.trending__grid');
      var dots = root.querySelectorAll('.trending__sdot');
      if (!grid || dots.length === 0) return;

      function cardStep() {
        var card = grid.querySelector('.trending-card');
        if (!card) return 1;
        var styles = window.getComputedStyle(grid);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return card.offsetWidth + gap;
      }

      function update() {
        var step = cardStep();
        var idx = Math.round(grid.scrollLeft / step);
        if (idx < 0) idx = 0;
        if (idx > dots.length - 1) idx = dots.length - 1;
        for (var i = 0; i < dots.length; i++) {
          if (i === idx) { dots[i].classList.add('is-active'); } else { dots[i].classList.remove('is-active'); }
        }
      }

      var ticking = false;
      grid.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(function () { ticking = false; update(); }); }
      }, { passive: true });

      for (var i = 0; i < dots.length; i++) {
        (function (di) {
          dots[di].addEventListener('click', function () {
            grid.scrollTo({ left: di * cardStep(), behavior: 'smooth' });
          });
        })(i);
      }

      update();
    }

    function initFlow(root) {
      if (root.dataset.flowReady === 'true') return;
      root.dataset.flowReady = 'true';
      if (!root.querySelector('.trending__flow')) return;
      if (!('IntersectionObserver' in window)) { root.classList.add('is-flow-revealed'); return; }
      var fio = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { root.classList.add('is-flow-revealed'); fio.disconnect(); }
      }, { threshold: 0.2 });
      fio.observe(root);
    }

    function boot() {
      var sections = document.querySelectorAll('.trending');
      for (var i = 0; i < sections.length; i++) { init(sections[i]); initFlow(sections[i]); }
    }

    if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
